import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { LocationsRepository } from '../../repositories';
import { RemoveLocationRequest } from '../../domain';

@Injectable({ providedIn: 'root' })
export class RemoveLocationUsecase implements UseCase<RemoveLocationRequest, boolean> {
  constructor(private readonly locationRepository: LocationsRepository) {}

  execute(params: RemoveLocationRequest): Observable<boolean> {
    return this.locationRepository.removeLocation(params);
  }
}
